var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolbarStrike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 8.66675H12.0001C11.68 8.66658 11.3646 8.74322 11.0803 8.89024C10.796 9.03725 10.5512 9.25035 10.3663 9.51162C10.1815 9.77289 10.062 10.0747 10.018 10.3917C9.97401 10.7087 10.0067 11.0317 10.1134 11.3334",
    stroke: "#2A3D4A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 14C16.0406 14 16.7189 14.281 17.219 14.781C17.719 15.2811 18 15.9594 18 16.6667C18 17.3739 17.719 18.0522 17.219 18.5523C16.7189 19.0524 16.0406 19.3333 15.3333 19.3333H10",
    stroke: "#2A3D4A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66699 14H19.3337",
    stroke: "#2A3D4A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarStrike);
export default __webpack_public_path__ + "static/media/toolbar-strike.fadb60cdb299fa9f1bd67059328695a9.svg";
export { ForwardRef as ReactComponent };